import { ToDateTimeText,ToDateText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import Alarm from '@material-ui/icons/Alarm';

export const getViewHistoryColumns = () => {
  const columns = [
    
    {
      dataField: "DATA_FILENAME",
      text: "File Name",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "DESCRIPTION",
      text: "Description",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "FREQUENCY",
      text: "Frequency",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "OWNER_EMAIL",
      text: "Owner",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
        dataField: "START_DATE",
        text: "Start date",
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>{ToDateText(row.START_DATE)}</>;
        },
        headerAlign: 'center',
        align: 'center',
      },

      {
        dataField: "END_DATE",
        text: "End date",
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>{ToDateText(row.END_DATE)}</>;
        },
        headerAlign: 'center',
        align: 'center',
      },
      // {
      //   dataField: "OP2",
      //   text: "",
      //   formatter: (cell, row) => {
      //     return (
      //       <Box component="div" display="flex" justifyContent="center">
      //         {(row.SHOW_EXTEND === 1) ?
      //         <Alarm
      //           color="action"
      //           onClick={() => {
      //             viewDetail(row.FILE_ID,row.END_DATE);
      //           }}
      //         />
      //         : ""}
      //       </Box>
      //     );
      //   },
      // },
      
  ];
  return columns;
};
export const getDetailUpload = () => {
  const columns = [
    {
      dataField: "ColumnName",
      text: "Column Name",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "Encrypt",
      text: "Encrypt Type",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
   
  ];
  return columns;
};
